export default __webpack_public_path__ + "static/media/1789.ae86e7f8.png";